class HeaderV3Controller extends HTMLElement {
    static get observedAttributes() {
      return ['data-theme', 'data-theme-transparent'];
    }
  
    constructor() {
      super();
  
      this.header = null;
      this.container = null;
      this.submenu = null;
  
      this.state = {
        bannerTheme: '',
        isTop: true,
        isHover: false,
        isScrollHide: false,
        isStopScrollShow: false, // 是否停止滚动时候显示header，前提是isScrollHide为true
        lastScrollY: 0,
        scrollDirection: 'up',
      };
  
      this.scrollRAF = null;
      this.hideTimer = null;
      this.showTimer = null;
      this.overlayTimer = null;
  
      this.handleScroll = this.handleScroll.bind(this);
      this.onMouseOver = this.onMouseOver.bind(this);
      this.onMouseOut = this.onMouseOut.bind(this);
    }
  
    connectedCallback() {
      this.initializeElements();
      this.initializeState();
      this.setupEventListeners();
    }
  
    disconnectedCallback() {
      this.cleanup();
    }
  
    initializeElements() {
      this.header = this.querySelector('header');
      this.container = this.querySelector('.header-container');
      this.submenu = this.querySelector('sub-menu');
      this.overlay = this.querySelector('.header-overlay');
    }
  
    initializeState() {
      this.state.isScrollHide = this.getAttribute('data-hide') === 'true';
      this.state.isStopScrollShow =
        this.getAttribute('data-stop-scroll-show') === 'true';
      this.state.lastScrollY = window.scrollY;
      this.setAttribute('data-theme-transparent', '');
    }
  
    setupEventListeners() {
      // 滚动事件
      window.addEventListener('scroll', this.handleScroll, { passive: true });
  
      // 鼠标悬停事件
      this.addEventListener('mouseover', this.onMouseOver);
      this.addEventListener('mouseout', this.onMouseOut);
  
      // 子菜单事件
      this.initSubmenuEvents();
    }
  
    initSubmenuEvents() {
      if (!this.submenu) return;
  
      const levelOneItems = this.querySelectorAll('.levelOne');
  
      levelOneItems.forEach((item) => {
        const menuText = item.innerText.trim();
        const submenuId = `submenu-${menuText}`;
  
        item.addEventListener('mouseenter', () => {
          // 下拉蒙版
          const subMenuEl = this.submenu.querySelector(`#${CSS.escape(submenuId)}`);
          if (subMenuEl) {
            if (this.overlayTimer) {
              clearTimeout(this.overlayTimer);
              this.overlayTimer = null;
            }
            this.submenu.setAttribute('data-active', submenuId);
            if (this.overlay) {
              this.overlay.style.opacity = '1';
            }
          } else {
            this.submenu.setAttribute('data-active', '');
            if (this.overlay) {
              this.overlay.style.opacity = '0';
            }
          }
        });
      });
  
      const hideMenuAndOverlay = () => {
        if (this.overlayTimer) {
          clearTimeout(this.overlayTimer);
        }
        this.overlayTimer = setTimeout(() => {
          if (!this.submenu.isHover && !this.matches(':hover')) {
             this.submenu.setAttribute('data-active', '');
             if (this.overlay) {
               this.overlay.style.opacity = '0';
             }
          }
        }, 100);
      };
  
      this.addEventListener('mouseleave', hideMenuAndOverlay);
      this.submenu.addEventListener('mouseleave', hideMenuAndOverlay);
    }
  
    onMouseOver() {
      this.state.isHover = true;
      this.setAttribute('data-theme-transparent', '');
  
      // 产品页面悬停时显示 header
      if (this.state.isScrollHide && this.container) {
        this.showHeader();
      }
    }
  
    onMouseOut() {
      this.state.isHover = false;
      this.setBannerTheme(this.state.bannerTheme);
    }
  
    handleScroll() {
      if (this.scrollRAF) return;
  
      this.scrollRAF = requestAnimationFrame(() => {
        this.updateScrollState();
        this.updateHeaderVisibility();
        this.updateTheme();
        this.scrollRAF = null;
      });
  
      if (!this.state.isStopScrollShow || !this.state.isScrollHide) {
        return;
      }
  
      if (this.showTimer) {
        clearTimeout(this.showTimer);
        this.showTimer = null;
      }
  
      this.showTimer = setTimeout(() => {
        this.showHeader();
      }, 1000);
    }
  
    updateScrollState() {
      const currentScrollY = window.scrollY;
      this.state.scrollDirection =
        currentScrollY > this.state.lastScrollY ? 'down' : 'up';
      this.state.isTop = currentScrollY <= 0;
      this.state.lastScrollY = currentScrollY;
    }
  
    updateHeaderVisibility() {
      if (!this.state.isScrollHide || !this.container) return;
  
      const { lastScrollY, scrollDirection, isHover } = this.state;
  
      if (lastScrollY > 100 && !isHover) {
        if (scrollDirection === 'down') {
          this.hideHeader();
        } else if (scrollDirection === 'up') {
          this.showHeader();
        }
      } else if (lastScrollY <= 100 || isHover) {
        this.showHeader();
      }
    }
  
    showHeader() {
      if (!this.container) return;
  
      this.container.style.transform = 'translateY(0)';
      this.container.style.transition = 'transform 0.3s ease';
  
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
      }
  
      // 延迟恢复 z-index 怕IP弹窗干扰
      this.hideTimer = setTimeout(() => {
        if (this.container) {
          this.container.style.zIndex = '1';
        }
      }, 300);
    }
  
    hideHeader() {
      if (!this.container) return;
  
      this.container.style.transform = 'translateY(-100%)';
      this.container.style.zIndex = '-1';
    }
  
    updateTheme() {
      const shouldBeTransparent = this.state.isTop && !this.state.isHover;
      this.setAttribute(
        'data-theme-transparent',
        shouldBeTransparent ? this.state.bannerTheme : ''
      );
    }
  
    // 监听属性变化
    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'data-theme-transparent' && oldValue !== newValue) {
        this.updateHeaderTheme();
      } else if (name === 'data-hide' && oldValue !== newValue) {
        this.state.isScrollHide = newValue === 'true';
      } else if (name === 'data-stop-scroll-show' && oldValue !== newValue) {
        this.state.isStopScrollShow = newValue === 'true';
      }
    }
  
    updateHeaderTheme() {
      if (!this.header || !this.container) return;
  
      const isTransparent = this.getAttribute('data-theme-transparent') !== '';
      const currentTheme = this.getAttribute('data-theme') || 'light';
  
      const THEME_CLASSES = {
        transparent: 'header_transparent',
        light: 'header_theme_light',
        dark: 'header_theme_dark',
      };
  
      this.header.classList.remove(
        THEME_CLASSES.transparent,
        THEME_CLASSES.light,
        THEME_CLASSES.dark
      );
  
      if (isTransparent) {
        this.header.classList.add(
          THEME_CLASSES.transparent,
          `header_theme_${this.state.bannerTheme || 'light'}`
        );
        this.container.style.backdropFilter = 'none';
      } else {
        this.header.classList.add(`header_theme_${currentTheme}`);
        this.container.style.backdropFilter = 'blur(30px)';
      }
    }
  
    setBannerTheme(theme) {
      this.state.bannerTheme = theme || this.state.bannerTheme || '';
      this.updateTheme();
    }
  
    cleanup() {
      window.removeEventListener('scroll', this.handleScroll);
      this.removeEventListener('mouseover', this.onMouseOver);
      this.removeEventListener('mouseout', this.onMouseOut);
  
      if (this.scrollRAF) {
        cancelAnimationFrame(this.scrollRAF);
        this.scrollRAF = null;
      }
  
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
      }
  
      if (this.overlayTimer) {
        clearTimeout(this.overlayTimer);
        this.overlayTimer = null;
      }
    }
  }
  
  class SubMenu extends HTMLElement {
    timer = null;
    static get observedAttributes() {
      return ['data-active', 'data-theme'];
    }
  
    constructor() {
      super();
      this.menuWrappers = null;
      this.isHover = false;
    }
  
    connectedCallback() {
      this.menuWrappers = this.querySelectorAll('.menu-wrapper');
      const subMenuContainer = this.querySelector('.sub-menu-container');
  
      if (subMenuContainer) {
        subMenuContainer.addEventListener('mouseenter', () => {
          this.isHover = true;
        });
  
        subMenuContainer.addEventListener('mouseleave', () => {
          this.isHover = false;
          this.updateActive();
        });
      }
    }
  
    disconnectedCallback() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }
  
    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'data-active' && oldValue !== newValue) {
        this.updateActive();
      }
    }
  
    updateActive() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
  
      this.timer = setTimeout(() => {
        if (this.isHover) return;
  
        const activeId = this.getAttribute('data-active');
        if (!this.menuWrappers || !activeId) {
          this.hideAllMenus();
          return;
        }
  
        const activeElement = this.querySelector(`#${CSS.escape(activeId)}`);
        if (!activeElement) {
          this.hideAllMenus();
          return;
        }
  
        this.menuWrappers.forEach((item) => {
          const isActive = item === activeElement;
  
          Object.assign(item.style, {
            opacity: '0',
            display: isActive ? 'block' : 'none',
            pointerEvents: isActive ? 'auto' : 'none',
            transform: isActive ? 'translateY(0)' : '',
          });
        });
  
        requestAnimationFrame(() => {
          if (activeElement) {
            activeElement.style.opacity = '1';
          }
        });
  
        this.timer = null;
      }, 0);
    }
  
    hideAllMenus() {
      if (!this.menuWrappers) return;
  
      this.menuWrappers.forEach((item) => {
        Object.assign(item.style, {
          opacity: '0',
          display: 'none',
          pointerEvents: 'none',
        });
      });
    }
  }
  
  customElements.define('header-control', HeaderV3Controller);
  customElements.define('sub-menu', SubMenu);
  